import React, { useEffect, useState } from "react";
import configData from "../../config.json";
import { CircularProgress } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";

function MultiAuthentication({ handleNewToken }) {
  const navigate = useNavigate();
  const params = useParams();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loginLoading, setLoginLoading] = useState(false);

  const handleLogin = () => {
    setError(null);
    setLoginLoading(true);
    let newBody = {
      multi: true,
      password: password,
      email: email,
    };
    fetch(`${configData.SERVER_URL}/Authentication/Login`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(newBody),
    })
      .then((response) => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error(response.statusText);
        }
      })
      .then((data) => {
        const expirationTimestamp = Date.UTC(
          Number(data.exp.slice(0, 4)), // Year
          Number(data.exp.slice(5, 7)) - 1, // Month (zero-based)
          Number(data.exp.slice(8, 10)), // Day
          Number(data.exp.slice(11, 13)), // Hour
          Number(data.exp.slice(14, 16)), // Minute
          Number(data.exp.slice(17, 19)) // Second
        );
        const expirationDate = new Date(expirationTimestamp);
        console.log(data.token);
        document.cookie = `token=${data.token
          }; path=/; expires=${expirationDate.toUTCString()}`;
        setLoginLoading(false);
        handleNewToken(true);
      })
      .catch((error) => {
        console.error(error.message);
        if (error.message === "UNAUTHORIZED") {
          setError("Invalid Username or Password");
          setLoginLoading(false);
        } else {
          setError(error.message);
          setLoginLoading(false);
        }
      });
  };
  return (
    <div className="container">
      {loginLoading === false ? (
        <div className="wifi-input-container">
          <h3 style={{ marginTop: "3vh", color: "black" }}>
            Login to Catch Field
          </h3>
          <div className="wifi-input-form">
            <div className="secondary-wifi-inputs">
              <div className="form-group">
                {error && (
                  <div class="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">
                    Email
                  </label>
                  <input
                    type="email"
                    class="form-control"
                    id="exampleFormControlInput2"
                    placeholder="name@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div class="mb-3">
                  <label for="exampleFormControlInput1" class="form-label">
                    Password
                  </label>
                  <input
                    type="password"
                    class="form-control"
                    id="exampleFormControlInput1"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </div>
              </div>

              <button className="btn btn-secondary" onClick={handleLogin}>
                Login
              </button>
            </div>
          </div>
        </div>
      ) : (
        <CircularProgress size={72} />
      )}
    </div>
  );
}

export default MultiAuthentication;
